import React from 'react';
import { withStyles, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';

const PF2MGenericButton = React.forwardRef(
  ({
    children,
    size,
    onClick,
    disabled,
    variant,
    color,
    classes,
    startIcon,
    className,
    type,
  }) => (
    <Button
      size={size}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      color={color}
      className={classNames(classes.root, className)}
      startIcon={startIcon}
      type={type}
    >
      {children}
    </Button>
  ),
);

PF2MGenericButton.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  classes: PropTypes.object.isRequired,
  startIcon: PropTypes.node,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
};

PF2MGenericButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  size: 'medium',
  variant: 'outlined',
  color: 'primary',
  startIcon: null,
  className: '',
  type: 'button',
};

export default withStyles(styles)(PF2MGenericButton);
